@if (pageSizeOptions?.length > 0) {
  <div class="col-md-12 pagination move-up --order-1">
    <div class="w-100 d-block d-md-flex">
      <div class="col-12 col-md-6 order-2 order-md-1">
        <div class="d-flex justify-content-center justify-content-md-start">
          <button mat-icon-button matTooltip="Advance Search" (click)="advanceSearch()">
            <mat-icon svgIcon="search"></mat-icon>
          </button>
          <button mat-icon-button matTooltip="Copy Table" (click)="copyTable()">
            <mat-icon svgIcon="copy"></mat-icon>
          </button>
          <div class="my-auto"><span class="vr"></span></div>
          <button mat-icon-button [matMenuTriggerFor]="pageSizeMenu" matTooltip="Select Page Size">
            <mat-icon svgIcon="next-page-arrow"></mat-icon>
          </button>
          <mat-menu #pageSizeMenu="matMenu">
            @for (pageOption of pageSizeOptions; track pageOption) {
              <button mat-menu-item (click)="setPageSize(pageOption)">
                <span>{{pageOption | number}}</span>
              </button>
            }
          </mat-menu>
          <button mat-icon-button [matMenuTriggerFor]="pageToGo" matTooltip="Go To Page">
            <mat-icon svgIcon="page-break"></mat-icon>
          </button>
          <mat-menu #pageToGo="matMenu">
            @for (page of pagination; track page) {
              <button mat-menu-item [disabled]="page === '...'"  (click)="setPage(page)">
                @if (page === '...') {
                  -- Middle --
                }
                @if (page !== '...') {
                  Page {{ page + 1 }} of {{ totalPage | number}}
                }
              </button>
            }
          </mat-menu>
          <button mat-icon-button (click)="openColumnSection()" matTooltip="Select Columns to Dispaly">
            <mat-icon svgIcon="columns"></mat-icon>
          </button>
          <!--        <div class="my-auto"><span class="vr"></span></div>-->
          <!--        <button mat-icon-button matTooltip="Export MS-Word">-->
          <!--          <mat-icon svgIcon="ms-word"></mat-icon>-->
        <!--        </button>-->
        <!--        <button mat-icon-button matTooltip="Export Excel">-->
        <!--          <mat-icon svgIcon="excel"></mat-icon>-->
      <!--        </button>-->
      <!--        <button mat-icon-button matTooltip="Export PDF">-->
      <!--          <mat-icon svgIcon="pdf"></mat-icon>-->
    <!--        </button>-->
  </div>
</div>
<div class="col-12 col-md-6 align-items-end order-1 order-md-2">
  <mat-paginator #paginator
    class="mat-paginator"
    (page)="handlePageEvent($event)"
    [length]="totalElement"
    [pageSize]="pageSize"
    [showFirstLastButtons]="showFirstLastButtons"
    [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
    [hidePageSize]="hidePageSize"
    [pageIndex]="currentPage"
    aria-label="Select page">
  </mat-paginator>
</div>
</div>
</div>
}
